/**
 * Locale bundles of the LinkedIn post tools (templates, AI writer, comments; FLAT `linkedinPostTools.*` keys). Explicit requires (Metro cannot
 * resolve dynamic paths); merged into the single `translation` namespace through locales/adminModules/index.js -> i18n.js.
 */
const BUNDLES = {
    hu: () => require('./hu.json'),
    en: () => require('./en.json'),
    de: () => require('./de.json'),
    ro: () => require('./ro.json'),
    cn: () => require('./cn.json'),
    svn: () => require('./svn.json'),
};

/**
 * @param {string} lng Language code (hu|en|de|ro|cn|svn).
 * @returns {object} Keys for the language ({} when unknown).
 */
export const getLinkedinPostToolsLocale = (lng) => (BUNDLES[lng] ? BUNDLES[lng]() : {});

export default getLinkedinPostToolsLocale;
